import React from 'react'

export interface SkeletonProps {
  width?: number | string
  height?: number | string
  circle?: boolean
  count?: number
  gap?: number | string
  style?: React.CSSProperties
}

export function Skeleton({ width, height = 16, circle, count = 1, gap = 8, style }: SkeletonProps) {
  const items = Array.from({ length: count }, (_, i) => (
    <div key={i} className="skeleton" style={{
      width: width || '100%', height, borderRadius: circle ? '50%' : undefined,
      ...style}} />
  ))
  if (count === 1) return items[0]
  return <div style={{ display: 'flex', flexDirection: 'column', gap }}>{items}</div>
}

export interface TableSkeletonProps {
  rows?: number
  cols?: number
}

export function TableSkeleton({ rows = 5, cols = 4 }: TableSkeletonProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} style={{ display: 'flex', gap: 12, padding: '10px 0' }}>
          {Array.from({ length: cols }, (_, j) => (
            <div key={j} className="skeleton" style={{
              height: 14, flex: j === 0 ? 2 : 1, borderRadius: 4}} />
          ))}
        </div>
      ))}
    </div>
  )
}
